import { useIntl } from '@weenat/wintl';
import { useState } from 'react';
import { isReactNative } from './utils';
const isNative = isReactNative();
/**
 * Return a prop object per key inside the ordering array.
 * This array is used to determine inputs order
 * and handle next focus when we submit an input editing
 */
const useOrderedFields = (ordering, formRefOrSubmit, options) => {
    const { t } = useIntl();
    const [currentFocus, setCurrentFocus] = useState(null);
    const labelSource = options?.labelSource;
    return ordering.reduce((acc, key, i) => {
        const nextKey = ordering[i + 1];
        acc[key] = {
            name: key,
            ...(options?.labelSource
                ? {
                    label: 
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    t(`${options.labelSource}.${key}`)
                }
                : {}),
            ...(options?.shared || {}),
            ...(isNative
                ? {
                    focus: currentFocus === key,
                    onFocus: () => setCurrentFocus(key),
                    ...(nextKey
                        ? {
                            onSubmitEditing: () => {
                                setCurrentFocus(nextKey);
                            }
                        }
                        : {
                            returnKeyType: 'send',
                            isSubmitable: true,
                            onSubmitEditing: () => {
                                if (formRefOrSubmit && 'current' in formRefOrSubmit) {
                                    formRefOrSubmit?.current?.handleSubmit();
                                }
                                else {
                                    formRefOrSubmit?.();
                                }
                            }
                        })
                }
                : {})
        };
        return acc;
    }, {});
};
export default useOrderedFields;
